import { RichTextInput } from "ra-input-rich-text";
import * as React from "react";
import { Pagination, List, Datagrid, TextField, NumberInput, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, PasswordInput } from 'react-admin';

import { PageListTitle, PageEditTitle, PageCreateTitle } from "../components/pageTitles";
import {default as commonStyles} from "../styles/common.js";
import Stack from '@mui/material/Stack';

export const AdministratorList = props => (
    <List exporter={false} {...props} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Liste des administrateurs" />
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="email" />
        </Datagrid>
    </List>
);

export const AdministratorEdit = props => (
    <Edit {...props}>
        <PageEditTitle text="Édition d'un administrateur" />
        <SimpleForm>
            <Stack direction="column" spacing={10} style={commonStyles.stackColumn}>
                <TextInput style={{...commonStyles.inputStyle, margin: "auto"}} disabled source="id" label="Id" />
                <TextInput style={{...commonStyles.inputStyle, margin: "auto"}} source="email" label="Email" validate={required()} type="email" />
                <PasswordInput style={{...commonStyles.inputStyle, margin: "auto"}} source="password" label="Mot de passe" validate={required()} defaultValue="" />
            </Stack>
        </SimpleForm>
    </Edit>
);

export const AdministratorCreate = props => (
    <Create {...props}>
        <PageCreateTitle text="Création d'un administrateur" />
        <SimpleForm>
            <Stack direction="column" spacing={10} style={commonStyles.stackColumn}>
                <TextInput source="email" label="Email" validate={required()} type="email" />
                <PasswordInput source="password" label="Mot de passe" validate={required()} />
            </Stack>
        </SimpleForm>
    </Create>
);